import _styled from "@emotion/styled-base";
import React, { useContext } from 'react';
import Media from 'react-media';
import { AdsenseContext } from '../AdsenseProvider';

var AdContainer = _styled("div", {
  target: "e16vz9ev0",
  label: "AdContainer"
})("display:flex;justify-content:center;margin-top:1rem;min-height:50px;*{text-align:center;}", function (_ref) {
  var theme = _ref.theme;
  return theme.MQ.M;
}, "{min-height:90px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BZHZlcnRpc2VtZW50L2luZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNOEIiLCJmaWxlIjoiLi4vLi4vc3JjL0FkdmVydGlzZW1lbnQvaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IE1lZGlhIGZyb20gJ3JlYWN0LW1lZGlhJ1xuXG5pbXBvcnQgeyBBZHNlbnNlQ29udGV4dCB9IGZyb20gJy4uL0Fkc2Vuc2VQcm92aWRlcidcblxuY29uc3QgQWRDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuXHRkaXNwbGF5OiBmbGV4O1xuXHRqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblx0bWFyZ2luLXRvcDogMXJlbTtcblx0bWluLWhlaWdodDogNTBweDtcblxuXHQqIHtcblx0XHR0ZXh0LWFsaWduOiBjZW50ZXI7XG5cdH1cblxuXHQkeyh7IHRoZW1lIH0pID0+IHRoZW1lLk1RLk19IHtcblx0XHRtaW4taGVpZ2h0OiA5MHB4O1xuXHR9XG5gXG5cbi8vIE9wdGlvbmFsIEFkIExlYWRlcmJvYXJkIHNwb3RcbmV4cG9ydCBmdW5jdGlvbiBBZHZlcnRpc2VtZW50KHsgaXNIdWJUZW1wbGF0ZSB9KSB7XG5cdGNvbnN0IHsgYWRzZW5zZU1lZGlhUXVlcnksIGhhc0Fkc2Vuc2UgfSA9IHVzZUNvbnRleHQoQWRzZW5zZUNvbnRleHQpXG5cblx0aWYgKCFoYXNBZHNlbnNlIHx8IGlzSHViVGVtcGxhdGUpIHtcblx0XHRyZXR1cm4gbnVsbFxuXHR9XG5cblx0cmV0dXJuIChcblx0XHQ8TWVkaWEgcXVlcnk9e2Fkc2Vuc2VNZWRpYVF1ZXJ5fSBkZWZhdWx0TWF0Y2hlcz17ZmFsc2V9PlxuXHRcdFx0eyhtYXRjaGVzKSA9PiBtYXRjaGVzICYmIDxBZENvbnRhaW5lciBpZD1cImFkX2xlYWRlcmJvYXJkXCIgLz59XG5cdFx0PC9NZWRpYT5cblx0KVxufVxuIl19 */")); // Optional Ad Leaderboard spot


export function Advertisement(_ref2) {
  var isHubTemplate = _ref2.isHubTemplate;

  var _useContext = useContext(AdsenseContext),
      adsenseMediaQuery = _useContext.adsenseMediaQuery,
      hasAdsense = _useContext.hasAdsense;

  if (!hasAdsense || isHubTemplate) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Media, {
    query: adsenseMediaQuery,
    defaultMatches: false
  }, function (matches) {
    return matches && /*#__PURE__*/React.createElement(AdContainer, {
      id: "ad_leaderboard"
    });
  });
}